import _ from 'lodash';
import { AbstractControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { FaqSchema, RegistrationSchema } from '../../campaign/structure/event-page';
import { ArrayValidators } from '../validators/array.validators';

export const SponsorSchema = {
  'fields': [{
    'field': 'imageFile',
    'value': null,
    'validators': [],
    'options': {
      'virtual': true
    }
  }, {
    'field': 'imageDataUrl',
    'value': '/images/blank_2x1.png',
    'validators': [],
    'options': {
      'virtual': true,
      'getter': (control) => {
        return control.value === '/images/blank_2x1.png' ? '' : control.value
      },
      'setter': (data, value) => {
        return _.get(data, 'imageUrl', '') === '' ? '/images/blank_2x1.png' : data.imageUrl
      }
    }
  }, {
    'field': 'imageUrl',
    'value': '/images/blank_2x1.png',
    'validators': [Validators.required],
    'options': {
      'getter': (control) => {
        return control.value === '/images/blank_2x1.png' ? '' : control.value
      },
      'setter': (data, value) => {
        return value === '' ? '/images/blank_2x1.png' : value
      }
    }
  }, {
    'field': 'name',
    'value': '',
    'validators': [Validators.maxLength(128)]
  }, {
    'field': 'sponsorUrl',
    'validators': [Validators.pattern('^(?:(?:http(s)?):\/\/(www\.)?)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]$')],
    'value': '',
  }]
};

export const SlideSchema = {
  'fields': [{
    'field': 'imageFile',
    'value': null,
    'validators': [],
    'options': {
      'virtual': true
    }
  }, {
    'field': 'imageDataUrl',
    'value': '/images/blank_2x1.png',
    'validators': [],
    'options': {
      'virtual': true,
      'getter': (control) => {
        return control.value === '/images/blank_2x1.png' ? '' : control.value
      },
      'setter': (data, value) => {
        return _.get(data, 'imageUrl', '') === '' ? '/images/blank_2x1.png' : data.imageUrl
      }
    }
  }, {
    'field': 'imageUrl',
    'value': '/images/blank_2x1.png',
    'validators': [Validators.required],
    'options': {
      'getter': (control) => {
        return control.value === '/images/blank_2x1.png' ? '' : control.value
      },
      'setter': (data, value) => {
        return value === '' ? '/images/blank_2x1.png' : value
      }
    }
  }, {
    'field': 'name',
    'value': '',
    'validators': [Validators.maxLength(512)]
  }]
};

export const EventConfigSchema = {
  'fields': [{
    'field': 'eventPageBlockType',
    'value': 4,
    'validators': [Validators.required]
  }
  ]
};

export const TextPartSchema = {
  'fields': [{
    'field': 'textBlock',
    'value': '',
    'validators': [ Validators.required]
  }, {
    'field': 'type',
    'value': 'text',
    'validators': []
  },
    {
      'field': 'textBlockTitle',
      'value': '',
      'validators': [Validators.required, Validators.maxLength(128)]
    },
    {
      'field': 'removeFromNav',
      'value': false,
      'validators': []
    },
    {
      'field': 'id',
      'value': null,
      'validators': []
    }
  ]
};

export const VideoContainerPartSchema = {
  'fields': [{
    'field': 'videoContainerDesc',
    'value': '',
    'validators': []
  }, {
    'field': 'type',
    'value': 'video',
    'validators': []
  },
    {
      'field': 'videoProvider',
      'value': 0,
      'validators': []
    },
    {
      'field': 'videoContainerTitle',
      'value': '',
      'validators': [Validators.maxLength(128)]
    },
    {
      'field': 'videoContainerUrl',
      'value': '',
      'validators': [Validators.required, Validators.maxLength(128)]
    },
    {
      'field': 'removeFromNav',
      'value': false,
      'validators': []
    },
    {
      'field': 'id',
      'value': null,
      'validators': []
    }
  ]
};

export const DonationCampaignPartSchema = {
  'fields': [{
    'field': 'campaignId',
    'value': '',
    'validators': [Validators.required]
  }, {
    'field': 'type',
    'value': 'donationCampaign',
    'validators': []
  },
    {
      'field': 'title',
      'value': '',
      'validators': [Validators.maxLength(128)]
    },
    {
      'field': 'campaignData',
      'value': {},
      'validators': []
    },
    {
      'field': 'removeFromNav',
      'value': false,
      'validators': []
    },
    {
      'field': 'id',
      'value': null,
      'validators': []
    }
  ]
};

export const SilentAuctionCampaignPartSchema = {
  'fields': [{
    'field': 'campaignId',
    'value': '',
    'validators': [Validators.required]
  }, {
    'field': 'type',
    'value': 'silentAuction',
    'validators': []
  },
    {
      'field': 'title',
      'value': '',
      'validators': [Validators.maxLength(128)]
    },
    {
      'field': 'campaignData',
      'value': {},
      'validators': []
    },
    {
      'field': 'removeFromNav',
      'value': false,
      'validators': []
    },
    {
      'field': 'id',
      'value': null,
      'validators': []
    }
  ]
};

export const LiveAuctionCampaignPartSchema = {
  'fields': [{
    'field': 'campaignId',
    'value': '',
    'validators': [Validators.required]
  }, {
    'field': 'type',
    'value': 'liveAuction',
    'validators': []
  },
    {
      'field': 'title',
      'value': '',
      'validators': [Validators.maxLength(128)]
    },
    {
      'field': 'campaignData',
      'value': {},
      'validators': []
    },
    {
      'field': 'removeFromNav',
      'value': false,
      'validators': []
    },
    {
      'field': 'id',
      'value': null,
      'validators': []
    }
  ]
};

export const RegistrationPartSchema = {
  'arrays': [{
    'array': 'buttons',
    'schema': RegistrationSchema,
    'value': [],
    'validators': []
  }],
  'fields': [{
    'field': 'type',
    'value': 'registration',
    'validators': []
  }
  ]
};

export const FaqPartSchema = {
  'arrays': [{
    'array': 'options',
    'schema': FaqSchema,
    'value': [],
    'validators': [Validators.required, ArrayValidators.minLength(1)]
  }],
  'fields': [{
    'field': 'type',
    'value': 'faq',
    'validators': []
  },
    {
      'field': 'faqBlockTitle',
      'value': '',
      'validators': [Validators.required, Validators.maxLength(128)]
    },
    {
      'field': 'removeFromNav',
      'value': false,
      'validators': []
    },
    {
      'field': 'id',
      'value': null,
      'validators': []
    }
  ]
};

export const SlidesPartSchema = {
  'arrays': [{
    'array': 'slides',
    'schema': SlideSchema,
    'value': [],
    'validators': [Validators.required, ArrayValidators.minLength(1)]
  }],
  'fields': [{
    'field': 'type',
    'value': 'slides',
    'validators': []
  },
    {
      'field': 'slidesBlockTitle',
      'value': '',
      'validators': [Validators.required, Validators.maxLength(128)]
    },
    {
      'field': 'removeFromNav',
      'value': false,
      'validators': []
    },
    {
      'field': 'id',
      'value': null,
      'validators': []
    }
  ]
};

export const ImagePartSchema = {
  'fields': [
    {
      'field': 'imageFile',
      'value': null,
      'validators': [],
      'options': {
        'virtual': true
      }
    }, 
    {
      'field': 'imageDataUrl',
      'value': '/images/blank_2x1.png',
      'validators': [],
      'options': {
        'virtual': true,
        'getter': (control) => {
          return control.value === '/images/blank_2x1.png' ? '' : control.value
        },
        'setter': (data, value) => {
          return _.get(data, 'imageUrl', '') === '' ? '/images/blank_2x1.png' : data.imageUrl
        }
      }
    }, 
    {
      'field': 'imageUrl',
      'value': '/images/blank_2x1.png',
      'validators': [Validators.required],
      'options': {
        'getter': (control) => {
          return control.value === '/images/blank_2x1.png' ? '' : control.value
        },
        'setter': (data, value) => {
          return value === '' ? '/images/blank_2x1.png' : value
        }
      }
    }, 
    {
      'field': 'imageBlockText',
      'value': 'some',
      'validators': []
    }, 
    {
      'field': 'type',
      'value': 'eventPageBlockTypeImage',
      'validators': []
    }, 
    {
      'field': 'imageBlockTitle',
      'value': '',
      'validators': [Validators.maxLength(128)]
    }, 
    {
      'field': 'removeFromNav',
      'value': false,
      'validators': []
    },
    {
      'field': 'id',
      'value': null,
      'validators': []
    }
  ]
};

export const ConfigurationSchema = {
  'arrays': [
    {
      'array': 'textPart',
      'schema': TextPartSchema,
      'value': [],
      'validators': []
    }, {
      'array': 'faqPart',
      'schema': FaqPartSchema,
      'value': [],
      'validators': []
    }, {
      'array': 'slidesPart',
      'schema': SlidesPartSchema,
      'value': [],
      'validators': []
    }, {
      'array': 'registrations',
      'schema': RegistrationPartSchema,
      'value': [],
      'validators': []
    }, {
      'array': 'donationCampaignPart',
      'schema': DonationCampaignPartSchema,
      'value': [],
      'validators': []
    }, {
      'array': 'silentAuctionCampaignPart',
      'schema': SilentAuctionCampaignPartSchema,
      'value': [],
      'validators': []
    }, {
      'array': 'liveAuctionCampaignPart',
      'schema': LiveAuctionCampaignPartSchema,
      'value': [],
      'validators': []
    }, {
      'array': 'videoContainerPart',
      'schema': VideoContainerPartSchema,
      'value': [],
      'validators': []
    }, {
      'array': 'imagePart',
      'schema': ImagePartSchema,
      'value': [],
      'validators': []
    }
  ],
  'fields': [
    {
      'field': 'showSponsors',
      'value': false,
      'validators': []
    },
    {
      'field': 'hideDateTime',
      'value': false,
      'validators': []
    },
    {
      'field': 'customDateTimeLabel',
      'value': '',
      'validators': [],
    },
    {
      'field': 'registrationButtonLabelRequired',
      'value': false,
      'validators': []
    },
    {
      'field': 'hideShareButtons',
      'value': false,
      'validators': []
    },
    {
      'field': 'registrationButtonLabel',
      'value': 'Register',
      'validators': [],
      'options': {
        'setter': (data, value) => value || '',
        'validators': (data) => {
            return data.registrationButtonLabelRequired ? [Validators.required] : [];
        }
      }
    },
    {
      'field': 'headerType',
      'value': 1,
      'validators': []
    },
    {
      'field': 'hideInPerson',
      'value': false,
      'validators': []
    },
    {
      'field': 'hideVirtual',
      'value': false,
      'validators': []
    },
    {
      'field': 'eventTheme',
      'value': false,
      'validators': [],
      'options': {
        'default': true,
        'setter': (data, value) => _.isEmpty(data.eventTheme) ? false : true
      }
    }, {
      'field': 'imageFile',
      'value': null,
      'validators': [],
      'options': {
        'virtual': true
      }
    }, {
      'field': 'imageDataUrl',
      'value': '/images/blank_2x1.png',
      'validators': [],
      'options': {
        'virtual': true,
        'getter': (control) => {
          return control.value === '/images/blank_2x1.png' ? '' : control.value
        },
        'setter': (data, value) => {
          return _.get(data, 'imageUrl', '') === '' ? '/images/blank_2x1.png' : data.imageUrl
        }
      }
    }, {
      'field': 'imageUrl',
      'value': '/images/blank_2x1.png',
      'validators': [],
      'options': {
        'getter': (control) => {
          return control.value === '/images/blank_2x1.png' ? '' : control.value
        },
        'setter': (data, value) => {
          return value === '' ? '/images/blank_2x1.png' : value
        }
      }
    }, {
      'field': 'name',
      'value': '',
      'validators': [Validators.maxLength(128)]
    }, {
      'field': 'desc',
      'value': '',
      'validators': []
    },
  ]
};


export const VirtualEventSchema = {
  'arrays': [
    {
      'array': 'sponsors',
      'schema': SponsorSchema,
      'value': [],
      'validators': []
    }, {
      'array': 'slides',
      'schema': SlideSchema,
      'value': [],
      'validators': []
    }, {
      'array': 'pageConfig',
      'schema': EventConfigSchema,
      'value': [],
      'validators': []
    }],
  'groups': [{
    'group': 'timeZoneData',
    'fields': [{
      'field': 'name',
      'value': () => moment.tz.guess(),
      'validators': [],
      'options': {
        'setter': (data, value) => _.isFunction(value) ? value() : value
      }
    }, {
      'field': 'abbr',
      'value': () => {
        const guess = moment.tz.guess();
        const zone = moment.tz.zone(guess);
        const timestamp = (new Date()).getTime();
        return zone.abbr(timestamp);
      },
      'validators': [],
      'options': {
        'setter': (data, value) => _.isFunction(value) ? value() : value
      }
    }, {
      'field': 'offset',
      'value': () => {
        const guess = moment.tz.guess();
        const zone = moment.tz.zone(guess);
        const timestamp = (new Date()).getTime();
        const abbr = zone.abbr(timestamp);
        const index = _.findIndex(zone.abbrs, (value) => _.isEqual(value, abbr));
        return zone.offsets[index] * -60;
      },
      'validators': [],
      'options': {
        'setter': (data, value) => _.isFunction(value) ? value() : value
      }
    }]
  }],
  'fields': [{
    'field': 'id',
    'value': null,
    'validators': []
  },
    {
      'field': 'eventPageBlockType',
      'value': 1,
      'validators': []
    }, {
      'field': 'removeFromNav',
      'value': false,
      'validators': [],
      'options': {
          'getter': (control) => {
              return control.value ? true: false;
          },
          'setter': (data, value) => (value === true) ? true: false
      }
    }, {
      'field': 'name',
      'value': '',
      'validators': [Validators.required, Validators.maxLength(128)]
    }, {
      'field': 'desc',
      'value': '',
      'validators': []
    },
    {
      'field': 'bannerDesc',
      'value': '',
      'validators': []
    }, {
      'field': 'imageFile',
      'value': null,
      'validators': [],
      'options': {
        'virtual': true
      }
    }, {
      'field': 'imageUrl',
      'value': '/images/blank_2x1.png',
      'validators': [],
      'options': {
        'getter': (control) => {
          return control.value === '/images/blank_2x1.png' ? '' : control.value
        },
        'setter': (data, value) => {
          return value === '' ? '/images/blank_2x1.png' : value
        }
      }
    }, {
      'field': 'imageDataUrl',
      'value': '/images/blank_2x1.png',
      'validators': [],
      'options': {
        'virtual': true,
        'getter': (control) => {
          return control.value === '/images/blank_2x1.png' ? '' : control.value
        },
        'setter': (data, value) => {
          return data.imageUrl === '' ? '/images/blank_2x1.png' : data.imageUrl
        }
      }
    }, {
      'field': 'eventType',
      'value': 0,
      'validators': []
    }, {
      'field': 'startDateTimeGmtUnix',
      'value': null,
      'validators': [Validators.required, Validators.nullValidator, Validators.min(1)],
    }, {
      'field': 'duration',
      'value': 60,
      'validators': [Validators.required, Validators.min(1), Validators.max(1440)],
      'options': {
          'setter': (data, value) => {
              if(_.isNumber(value)) {
                  return value < 1 ? 60: value;
              }
              return 60;
          }
      }
    }, {
      'field': 'goal',
      'value': 0,
      'validators': [],
      'options': {
        'getter': (control) => parseFloat(control.value)
      }
    }, {
      'field': 'streamProvider',
      'value': 0,
      'validators': []
    }, {
      'field': 'streamUrl',
      'value': '',
      'validators': []
    }, {
      'field': 'donorStreetAddressNeeded',
      'value': false,
      'validators': []
    }, {
      'field': 'donorPhoneNeeded',
      'value': false,
      'validators': []
    }, {
      'field': 'showGoalToDonors',
      'value': true,
      'validators': []
    }, {
      'field': 'hideDonorFee',
      'value': false,
      'validators': []
    }, {
      'field': 'additionalInfoRequired',
      'value': false,
      'validators': []
    }, {
      'field': 'additionalInfoName',
      'value': '',
      'validators': []
    }, {
      'field': 'showAnonymous',
      'value': false,
      'validators': []
    }, {
      'field': 'showBanner',
      'value': false,
      'validators': []
    },
    {
      'field': 'defaultDonateCampaignRequired',
      'value': false,
      'validators': [],
      'options': {
        'virtual': true,
        'setter': (data, value) => _.isEmpty(data.defaultDonateCampaignId) ? false : true
      }
    }, {
      'field': 'defaultDonateCampaignData',
      'value': null,
      'validators': []
    }, {
      'field': 'defaultDonateCampaignId',
      'value': '',
      'validators': []
    }, {
      'field': 'pledgeBehaviour',
      'value': 0,
      'validators': []
    }, {
      'field': 'lobbyMusic',
      'value': '/images/bensound-elevate.mp3',
      'validators': []
    }, {
      'field': 'endMusic',
      'value': '/images/bensound-happyrock.mp3',
      'validators': []
    }, {
      'field': 'timeZoneList',
      'value': () => {
        const timestamp = new Date().getTime() / 1000;
        const zones = moment.tz.names();
        return _.map(zones, (name, index) => {
          const label = `(GMT ${moment.tz(timestamp, name).format('Z')}) ${name} - ${moment.tz(timestamp, name).format('z')}`;
          return {index, label, value: name};
        });
      },
      'validators': [],
      'options': {
        'virtual': true,
        'setter': (data, value) => _.isFunction(value) ? value() : value
      }
    }, {
      'field': 'timeZone',
      'value': () => (new Date()).getTimezoneOffset() * -60,
      'validators': [Validators.required],
      'options': {
        'setter': (data, value) => _.isFunction(value) ? value() : value
      }
    }, {
      'field': 'timeZoneAbbr',
      'value': () => (new Date()).toLocaleTimeString('en-us', {timeZoneName: 'short'}).split(' ')[2],
      'validators': [],
      'options': {
        'setter': (data, value) => _.isFunction(value) ? value() : value
      }
    }, {
      'field': 'inviteMessage',
      'value': '',
      'validators': []
    }, {
      'field': 'inviteMessageObject',
      'value': '',
      'validators': []
    }, {
      'field': 'confirmMessage',
      'value': '',
      'validators': []
    }, {
      'field': 'confirmMessageObject',
      'value': '',
      'validators': []
    }]
};
